import * as types from '../constants';
import _ from 'lodash';
import {
  listOrderHistory,
  getOrderDetail,
  getMemberCurrentLocation,
  listOrderHistoryForShip,
  getOrderDetailForShip
} from '../../clientServices/order'

export const getListOrderHistory = body => dispatch => {
  listOrderHistory(body)
    .then(res=>{
      dispatch({
        type: types.GET_LIST_ORDER_HISTORY,
        payload: _.get(res, 'data', [])
      })
    }).catch(e=>console.log(e))
}

export const getListOrderHistoryForShip = body => dispatch => {
  listOrderHistoryForShip(body)
    .then(res=>{
      dispatch({
        type: types.GET_LIST_ORDER_HISTORY,
        payload: _.get(res, 'data', [])
      })
    }).catch(e=>console.log(e))
}

export const getOrderDetailForShop = (id, cb) => dispatch => {
  if (!id) return;
  getOrderDetail({id})
  .then(res=>{
    dispatch({
      type: types.GET_ORDER_DETAIL,
      payload: _.get(res, 'data',{})
    })
    typeof cb === 'function' && cb(_.get(res, 'data',{}));
  }).catch(e=>console.log(e))
}

export const getOrderDetailForShipRD = (id, cb) => dispatch => {
  if (!id) return;
  getOrderDetailForShip({id})
  .then(res=>{
    dispatch({
      type: types.GET_ORDER_DETAIL,
      payload: _.get(res, 'data',{})
    })
    typeof cb === 'function' && cb(_.get(res, 'data',{}));
  }).catch(e=>console.log(e))
}

export const getShipperMoving = (data) => dispatch => {
    dispatch({
      type: types.GET_SHIPPER_MOVING,
      payload: data
    })
}
